import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/About.css';
// Import local images
import aboutHero from '../assets/images/home.jpg';      // Hero image
import aboutStory from '../assets/images/exterior.jpg';    // Story image

const About = () => {
    return (
        <div className="about-page">
            <Header />
            
            {/* Hero Section */}
            <section className="about-hero">
                <div 
                    className="about-hero-image" 
                    style={{
                        backgroundImage: `linear-gradient(rgba(44,62,80,0.7), rgba(44,62,80,0.7)), url(${aboutHero})`
                    }}
                ></div>
                <div className="hero-content">
                    <h1>About Maison Mosh II</h1>
                    <p>Premium Guest House in Moshoeshoe II, Maseru</p>
                </div>
            </section>

            {/* Our Story */}
            <section className="our-story">
                <div className="container">
                    <div className="story-grid">
                        <div className="story-text">
                            <span className="section-tag">OUR STORY</span>
                            <h2>A Vision of Comfort & Luxury</h2>
                            <div className="heading-underline"></div>
                            <p className="story-paragraph">
                                Maison Mosh II is a premium guest house located in the prestigious 
                                Moshoeshoe II suburb of Maseru. We offer comfortable, well-appointed 
                                accommodations for corporate travelers, consultants, and discerning guests 
                                visiting Lesotho.
                            </p>
                            <p className="story-paragraph">
                                Our 8 rooms are named after Basotho clans, reflecting our pride in Lesotho's 
                                rich cultural heritage. Each room is designed with your comfort in mind, 
                                featuring modern amenities and a peaceful atmosphere.
                            </p>
                        </div>
                        <div className="story-image">
                            <img 
                                src={aboutStory} 
                                alt="Maison Mosh II Guest House"
                                className="story-img"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Philosophy */}
            <section className="philosophy">
                <div className="container">
                    <div className="philosophy-header">
                        <span className="section-tag">OUR PHILOSOPHY</span>
                        <h2>What We Stand For</h2>
                        <div className="philosophy-underline"></div>
                    </div>
                    <div className="philosophy-grid">
                        <div className="philosophy-card">
                            <h3>Comfort</h3>
                            <p>Premium bedding, quality linens, and thoughtful amenities for a restful stay.</p>
                        </div>
                        <div className="philosophy-card">
                            <h3>Privacy</h3>
                            <p>A secure, tranquil environment designed for your peace of mind.</p>
                        </div>
                        <div className="philosophy-card">
                            <h3>Hospitality</h3>
                            <p>Warm, personalized service that makes every guest feel welcome.</p>
                        </div>
                        <div className="philosophy-card">
                            <h3>Convenience</h3>
                            <p>High-speed WiFi, secure parking, and modern amenities for business and leisure.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="why-choose">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">WHY CHOOSE US</span>
                        <h2>Why Guests Love Maison Mosh II</h2>
                    </div>
                    
                    <div className="features-grid">
                        <div className="feature">
                            <div className="feature-number">01</div>
                            <h3>Premium Location</h3>
                            <p>Ideally situated in Moshoeshoe II, close to government offices, businesses, and attractions.</p>
                        </div>
                        <div className="feature">
                            <div className="feature-number">02</div>
                            <h3>Secure Environment</h3>
                            <p>24/7 security with gated parking for complete peace of mind.</p>
                        </div>
                        <div className="feature">
                            <div className="feature-number">03</div>
                            <h3>Modern Amenities</h3>
                            <p>High-speed WiFi, premium bedding, and all the comforts of home.</p>
                        </div>
                        <div className="feature">
                            <div className="feature-number">04</div>
                            <h3>Convenient Access</h3>
                            <p>Easy access to government ministries, businesses, and local attractions.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="about-cta">
                <div className="container">
                    <h2>Experience Maison Mosh II</h2>
                    <p>Book your stay and enjoy comfort and convenience in Maseru</p>
                    <div className="cta-buttons">
                        <Link to="/rooms" className="btn btn-primary">View Our Rooms</Link>
                        <Link to="/contact" className="btn btn-outline">Contact Us</Link>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default About;